import { Input } from "antd";
import React, { forwardRef } from "react";
import InputMask from "react-input-mask";
import PropTypes from "prop-types";

const MobileInputMask = forwardRef((props, ref) => {
  const { value, onChange, ...restProps } = props;

  return (
    <InputMask {...restProps} value={value || ""} onChange={onChange}>
      {(inputProps) => (
        <Input
          {...inputProps}
          ref={ref}
          disabled={props.disabled ? props.disabled : null}
        />
      )}
    </InputMask>
  );
});

MobileInputMask.propTypes = {
  mask: PropTypes.string,
  maskChar: PropTypes.string,
  formatChars: PropTypes.object,
  alwaysShowMask: PropTypes.bool,
  inputRef: PropTypes.func,
  value: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default MobileInputMask;
